import { render, staticRenderFns } from "./LoginRe.vue?vue&type=template&id=6b5a2470&"
import script from "./LoginRe.vue?vue&type=script&lang=js&"
export * from "./LoginRe.vue?vue&type=script&lang=js&"
import style0 from "./LoginRe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports